<template>
  <div id="main-cid-detail" class="container cid-detail">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            :to="`/?sessionToken=${this.$route.query.sessionToken}&apartmentId=${this.$route.query.apartmentId}`"
          >หน้าหลัก</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">รายละเอียดสินค้า</li>
      </ol>
    </nav>
    <div class="container-img">
      <loading-grid class="loading-grid-img" v-show="isLoadImage" />
      <img :src="imageUrl" alt="Baner" @load="loaded()" />
    </div>

    <div class="row">
      <div class="col-md-6">
        <images-carousel v-if="product.get('images').length > 0" :Images="product.get('images')" />
      </div>
      <div class="col-md-6 container-detail">
        <div class="product-name">{{product.get('name')}}</div>
        <p class="viewer-count">จำนวนการดู {{product.get('viewerCounter') || 0}} ครั้ง</p>
        <p
          class="viewer-count"
          v-if="balanceStore"
          v-show="!isLoadBalanceStore"
        >จำนวนคงเหลือ {{balanceStore.balanceProduct || 0}} เครื่อง</p>
        <loading-worm class="viewer-count" v-if="isLoadBalanceStore" size="small" />
        <!-- <p v-if="product.get('price')">ราคา {{product.get('price')}} .บาท / {{product.get('unitType')}}</p> -->
        <div class="box-detail" v-if="product.get('detail')">
          <h4>คุณสมบัติสินค้า</h4>
          <div class="html-detail" v-html="product.get('detail')"></div>
        </div>
        <!-- <div class="box-detail" v-if="product.get('description')">
          <h4>ข้อมูลสินค้า</h4>
          
        </div>-->
        <div class="box-btn-quotation" v-show="!isLoadInit" v-if="product.get('quotationLink')">
          <button
            type="button"
            :class="`btn-quotation ${isLoadBalanceStore || (balanceStore && balanceStore.balanceProduct <= 0) ? 'non-active':''}`"
            @click="requestQuotation()"
          >{{lastPurchase ? text.btnPurchase2 : text.btnPurchase}}</button>
          <button
            type="button"
            class="btn-quotation"
            @click="clickRegister()"
          >{{registerData && registerData.isSuccess ? text.btnRegister : text.btnRegister2}}</button>
          <div
            class="text-last-purchase"
            v-if="lastPurchase"
          >{{`ซื้อครั้งล่าสุด(${dateFormat(lastPurchase.get('purchaseDate'),'DD/MM/YY')}) ${lastPurchase.get('orders')[0].number} ชิ้น`}}</div>
        </div>
        <div class="box-btn-quotation" v-show="isLoadInit">
          <loading-cycle />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="box-information" v-if="product.get('description')">
          <div class="head">รายละเอียดสินค้า</div>
          <div class="html-detail" v-html="product.get('description')"></div>
        </div>
      </div>
    </div>

    <div id="modal-purchase" class="modal-purchase modal-purchase-hide">
      <div class="container container-purchase">
        <div class="header-purchase">
          <div class="text">{{lastPurchase ? text.btnPurchase2 : text.btnPurchase}}</div>
          <div class="box-close" @click="toggleModalPurchase">
            <i class="fas fa-times close-modal"></i>
          </div>
        </div>
        <div class="paging">
          <div
            :class="`paging-page ${pageOpen[1]?'o':'x'} ${pageNo == 1 ? 'active':''}`"
            @click="()=>{pageLR ='r'; pageNo = 1;}"
          >การสั่งซื้อ</div>
          <div
            :class="`paging-page ${pageOpen[2]?'o':'x'} ${pageNo == 2 ? 'active':''}`"
            @click="()=>{pageNo >= 3 ? pageLR = 'l':pageLR ='r'; pageNo = 2;}"
          >สถานที่จัดส่ง</div>
          <div
            :class="`paging-page ${pageOpen[3]?'o':'x'} ${pageNo == 3 ? 'active':''}`"
            @click="()=>{pageNo >= 4 ? pageLR = 'l':pageLR ='r';; pageNo = 3;}"
          >การชำระเงิน</div>
          <div
            :class="`paging-page ${pageOpen[4]?'o':'x'} ${pageNo == 4 ? 'active':''}`"
            @click="()=>{pageLR = 'l'; pageNo = 4;}"
          >การสั่งซื้อสำเร็จ</div>
        </div>
        <div class="panel">
          <div :class="`t t1 ${pageNo == 1 ? 'active' :''}`">
            <div class="row">
              <div class="col col-md-8">
                <div class="box-list-product" v-if="items && items[0]">
                  <div class="box-image">
                    <img :src="items[0].image._url" :alt="items[0].image._name" />
                  </div>
                  <div class="box-text">
                    <div class="head">{{product.get("name")}}</div>
                    <div class="type">Horganice</div>
                    <div class="promotion">
                      <img src="../assets/icon/sendfree.png" alt="promo" />
                    </div>
                  </div>
                  <div class="box-number">
                    <i
                      :class="`fas fa-minus ${formPurchase.number < 1 ? 'none':''}`"
                      @click="numberPluse('-')"
                    ></i>
                    <input
                      type="number"
                      name="number-order"
                      id="number-order"
                      v-model.number="formPurchase.number"
                      placeholder="จำนวน"
                      min="1"
                      max="9"
                      @keypress="isNumberPurchase()"
                      @input="changeNumber()"
                    />
                    <i
                      :class="`fas fa-plus ${formPurchase.number >=9 ? 'none':''}`"
                      @click="numberPluse('+')"
                    ></i>
                  </div>
                  <div class="box-price">
                    <div
                      class="span-price"
                      v-if="product.get('fullPrice') && product.get('fullPrice') > product.get('price')"
                    >
                      จากราคา
                      <span>{{eArabic(product.get('fullPrice'),2) }}</span>
                    </div>
                    <div class="text-price">฿ {{eArabic(product.get('price'),2) }}</div>
                    <div class="span-vat" v-if="product.get('isIncludeVat')">(รวมภาษีแล้ว)</div>
                  </div>
                </div>
              </div>
              <div class="col col-md-4">
                <div class="box-conclusion">
                  <div class="head">สรุปรายการสั่งซื้อ</div>
                  <table>
                    <tr>
                      <th>ยอดรวมก่อนภาษี (จำนวน {{formPurchase.number}} ชิ้น)</th>
                      <td>฿{{eArabic(formPurchase.beforeVat,2)}}</td>
                    </tr>
                    <tr>
                      <th>ภาษี {{formPurchase.vatPer}}%</th>
                      <td>฿{{eArabic(formPurchase.vatBath,2)}}</td>
                    </tr>
                    <tr>
                      <th>ค่าจัดส่ง</th>
                      <td>฿{{eArabic(formPurchase.deliveryBath,2)}}</td>
                    </tr>
                    <tr>
                      <th class="sum">ราคาสุทธิ</th>
                      <td class="sum">฿{{eArabic(formPurchase.cost,2)}}</td>
                    </tr>
                  </table>
                  <div
                    @click.prevent="submitPurchaseOrder1(formPurchase)"
                    :class="`btn-purchase-order ${formPurchase.number < 1 ? 'non-active':''}`"
                  >ดำเนินการที่อยู่จัดส่ง</div>
                  <div class="text-require" v-html="checkFormPurchase"></div>
                </div>
              </div>
            </div>
          </div>
          <div :class="`t ${pageLR == 'r' ? 't2R' : 't2L'} ${pageNo == 2 ? 'active' :''}`">
            <div class="row">
              <div class="col col-md-8">
                <div class="box-list-product">
                  <div class="box-image" v-if="items && items[0]">
                    <img :src="items[0].image._url" :alt="items[0].image._name" />
                  </div>
                  <div class="box-text">
                    <div class="head">{{product.get("name")}}</div>
                    <div class="type">Horganice</div>
                    <div class="promotion">
                      <img src="../assets/icon/sendfree.png" alt="promo" />
                    </div>
                  </div>
                  <div class="box-number address">จำนวน : {{formPurchase.number}}</div>
                  <div class="box-price">
                    <div
                      class="span-price"
                      v-if="product.get('fullPrice') && product.get('fullPrice') > product.get('price')"
                    >
                      จากราคา
                      <span>{{eArabic(product.get('fullPrice'),2) }}</span>
                    </div>
                    <div class="text-price">฿ {{eArabic(formPurchase.pricePer,2) }}</div>
                    <div class="span-vat" v-if="product.get('isIncludeVat')">(รวมภาษีแล้ว)</div>
                  </div>
                </div>
              </div>
              <div class="col col-md-4">
                <div class="box-conclusion">
                  <div class="head">สรุปรายการสั่งซื้อ</div>
                  <table>
                    <tr>
                      <th>ยอดรวมก่อนภาษี (จำนวน {{formPurchase.number}} ชิ้น)</th>
                      <td>฿{{eArabic(formPurchase.beforeVat,2)}}</td>
                    </tr>
                    <tr>
                      <th>ภาษี {{formPurchase.vatPer}}%</th>
                      <td>฿{{eArabic(formPurchase.vatBath,2)}}</td>
                    </tr>
                    <tr>
                      <th>ค่าจัดส่ง</th>
                      <td>฿{{eArabic(formPurchase.deliveryBath,2)}}</td>
                    </tr>
                    <tr>
                      <th class="sum">ราคาสุทธิ</th>
                      <td class="sum">฿{{eArabic(formPurchase.cost,2)}}</td>
                    </tr>
                  </table>
                  <div
                    @click.prevent="submitPurchaseOrder2(formPurchase)"
                    :class="`btn-purchase-order ${!checkAddress? 'non-active':''}`"
                  >ดำเนินการชำระเงิน</div>
                  <div class="text-require" v-html="checkFormAddress"></div>
                </div>
              </div>
            </div>
            <div class="row row-bottom">
              <div class="col col-md-12">
                <div class="head">กรุณาตรวจสอบข้อมูลสำหรับการจัดส่ง</div>
              </div>
              <div class="col col-md-6">
                <div class="box-form-in">
                  <label for="who-purchase">
                    ชื่อผู้สั่งซื้อ
                    <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="who-purchase"
                    name="who-purchase"
                    required
                    v-model="formPurchase.userName"
                    placeholder="ชื่อผู้สั่งซื้อ"
                  />
                </div>
                <div class="box-form-in">
                  <label for="tel-purchase">
                    เบอร์โทรติดต่อ ( ผู้สั่งซื้อ )
                    <span class="required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="tel-purchase"
                    id="tel-purchase"
                    required
                    v-model="formPurchase.userTel"
                    placeholder="เบอร์โทรติดต่อ ( ผู้สั่งซื้อ )"
                  />
                </div>
                <div class="box-form-in">
                  <label for="tel-purchase-2">เบอร์โทรติดต่อ ( สำรอง )</label>
                  <input
                    type="tel"
                    name="tel-purchase-2"
                    id="tel-purchase-2"
                    v-model="formPurchase.apartmentTel"
                    placeholder="เบอร์โทรติดต่อ ( ตึก )"
                  />
                </div>
                <div class="note-star">
                  <span class="star">*</span>หมายถึง จำเป็นต้องใส่ข้อมูล
                </div>
              </div>
              <div class="col col-md-6">
                <div class="box-form-in">
                  <label for="name-purchase">
                    ชื่อหอพัก
                    <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="name-purchase"
                    name="name-purchase"
                    required
                    v-model="formPurchase.apartmentName"
                    placeholder="ชื่อหอพัก"
                  />
                </div>
                <div class="box-form-in">
                  <label for="address-purchase">
                    ที่อยู่จัดส่ง
                    <span class="required">*</span>
                  </label>
                  <textarea
                    name="address-purchase"
                    id="address-purchase"
                    v-model="formPurchase.apartmentAddress"
                    placeholder="ที่อยู่จัดส่ง"
                  ></textarea>
                </div>
                <div class="box-form-in">
                  <label for="note-purchase">หมายเหตุ</label>
                  <textarea
                    class="note"
                    name="note-purchase"
                    id="note-purchase"
                    v-model="formPurchase.note"
                    placeholder="หมายเหตุ"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div :class="`t ${pageLR == 'r' ? 't3R' : 't3L'} t3 ${pageNo == 3 ? 'active' :''}`">
            <div class="row">
              <div class="col col-md-8">
                <div class="head">ช่องทางการชำระเงิน</div>
                <div class="box-banks">
                  <div class="box-bank">
                    <div>
                      <i class="fas fa-dollar-sign"></i>
                    </div>
                    <div class="text">โมบายแบงค์กิ้ง/การโอนเงิน</div>
                  </div>
                  <div class="box-bank non-active">
                    <div>
                      <i class="fas fa-hand-holding-usd"></i>
                    </div>
                    <div class="text">การเก็บเงินปลายทาง</div>
                  </div>
                </div>
                <div class="box-list-bank" v-if="banks">
                  <div class="image-bank">
                    <img :src="getImage" alt="KBANK" />
                  </div>
                  <div class="text-bank">
                    <div class="account-name">{{banks[0].bankAccount}}</div>
                    <div class="account-no">{{banks[0].bankAccountNo}}</div>
                    <div class="bank-name">{{banks[0].bankName}}</div>
                  </div>
                  <div class="cost">
                    <div class="text">ยอดโอน</div>
                    <div class="number">฿ {{eArabic(formPurchase.cost,2)}}</div>
                  </div>
                </div>
              </div>
              <div class="col col-md-4">
                <div class="box-conclusion">
                  <div class="head">ที่อยู่ในการจัดส่ง</div>
                  <table class="address">
                    <tr>
                      <th>
                        <i class="fas fa-map-marker-alt"></i>
                        {{formPurchase.userName}}
                      </th>
                    </tr>
                    <tr>
                      <td
                        class="address"
                      >{{`${formPurchase.apartmentName} ${formPurchase.apartmentAddress}`}}</td>
                    </tr>
                    <tr>
                      <td>
                        <i class="fas fa-phone-alt"></i>
                        {{formPurchase.userTel}}
                      </td>
                    </tr>
                  </table>
                  <div class="head">สรุปรายการสั่งซื้อ</div>
                  <table>
                    <tr>
                      <th>ยอดรวมก่อนภาษี (จำนวน {{formPurchase.number}} ชิ้น)</th>
                      <td>฿{{eArabic(formPurchase.beforeVat,2)}}</td>
                    </tr>
                    <tr>
                      <th>ภาษี {{formPurchase.vatPer}}%</th>
                      <td>฿{{eArabic(formPurchase.vatBath,2)}}</td>
                    </tr>
                    <tr>
                      <th>ค่าจัดส่ง</th>
                      <td>฿{{eArabic(formPurchase.deliveryBath,2)}}</td>
                    </tr>
                    <tr>
                      <th class="sum">ราคาสุทธิ</th>
                      <td class="sum">฿{{eArabic(formPurchase.cost,2)}}</td>
                    </tr>
                  </table>
                  <div
                    @click="requestPurchase()"
                    :class="`btn-purchase-order ${formPurchase.number < 1 || isSavingImageProof || !formPurchase.proofOfPayment ? 'non-active':''}`"
                  >ยืนยันการชำระเงิน</div>
                  <div class="text-require" v-html="checkFormProof"></div>
                </div>
              </div>
            </div>
            <div class="row row-bottom">
              <div class="col col-md-12">
                <div class="head">กรุณาตรวจสอบข้อมูลในการออกใบกำกับภาษี</div>
              </div>
              <div class="col col-md-12">
                <div class="box-form-in">
                  <div class="same-data">
                    <label for="same-address">ชื่อเดียวกับข้อมูลจัดส่ง</label>
                    <input
                      type="checkbox"
                      name="same-address"
                      id="same-address"
                      v-model="formPurchase.isSameName"
                      @change="changeSame"
                    />
                  </div>
                  <div class="box-input">
                    <label for="who-purchase-tax">
                      ชื่อผู้สั่งซื้อ/ชื่อบริษัท
                      <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="who-purchase-tax"
                      name="who-purchase-tax"
                      required
                      v-model="formPurchase.userNameTax"
                      placeholder="ชื่อผู้สั่งซื้อ/ชื่อบริษัท"
                    />
                  </div>
                </div>
                <div class="box-form-in">
                  <div class="same-data"></div>
                  <div class="box-input">
                    <label for="tax-id">
                      เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี
                      <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="tax-id"
                      name="tax-id"
                      required
                      v-model="formPurchase.taxId"
                      placeholder="Tax ID"
                    />
                  </div>
                </div>
                <div class="box-form-in">
                  <div class="same-data">
                    <label for="same-address">ที่อยู่เดียวกับที่อยู่จัดส่ง</label>
                    <input
                      type="checkbox"
                      name="same-address"
                      id="same-address"
                      v-model="formPurchase.isSameAddress"
                      @change="changeSame"
                    />
                  </div>
                  <div class="box-input">
                    <label for="address-purchase-tax">
                      ที่อยู่ในการออกใบกำกับภาษี
                      <span class="required">*</span>
                    </label>
                    <textarea
                      name="address-purchase-tax"
                      id="address-purchase-tax"
                      v-model="formPurchase.apartmentAddressTax"
                      placeholder="Address"
                    ></textarea>
                  </div>
                </div>
                <div class="note-star">
                  <span class="star">*</span>หมายถึง จำเป็นต้องใส่ข้อมูล
                </div>
              </div>
            </div>
            <div class="row row-bottom">
              <div class="col col-md-12">
                <div class="head">แนบหลักฐานการโอน</div>
              </div>
              <div class="col col-md-6">
                <div class="box-image">
                  <div class="box-image-proof">
                    <img
                      v-if="formPurchase && formPurchase.proofOfPayment"
                      :src="`data:image/*;base64,${formPurchase.proofOfPayment._data}`"
                      alt
                    />
                  </div>
                </div>
              </div>
              <div class="col col-md-6">
                <div class="box-proof">
                  <label
                    :class="`btn btn-proof-of-payment ${isSavingImageProof ? 'not-active' :''}`"
                    for="proof-of-payment"
                  >
                    {{formPurchase.proofOfPayment ? 'เปลี่ยนรูปหลักฐาน':'แนบรูปหลักฐาน'}}
                    <i
                      class="fas fa-upload loadding-spinner m"
                      v-show="!isSavingImageProof && !formPurchase.proofOfPayment"
                    ></i>
                    <i class="fa fa-spinner fa-spin loadding-spinner m" v-show="isSavingImageProof"></i>
                    <i
                      class="far fa-check-circle loaded-checked l"
                      v-show="formPurchase.proofOfPayment && !isSavingImageProof"
                    ></i>
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    tabindex="-1"
                    id="proof-of-payment"
                    @input="processImageProof"
                    style="display:none;"
                  />
                </div>
              </div>
            </div>
          </div>
          <div :class="`t t4 ${pageNo == 4 ? 'active' :''}`">
            <div class="row">
              <div class="col col-md-12">
                <div class="box-success-purchase" v-if="lastPurchase">
                  <div class="icon">
                    <i
                      v-show="lastPurchase.get('isConfirm') && !lastPurchase.get('isCancel')"
                      class="fas fa-clipboard-check success"
                    ></i>
                    <i
                      v-show="!lastPurchase.get('isConfirm') && !lastPurchase.get('isCancel')"
                      class="fas fa-user-clock wait"
                    ></i>
                    <i v-show="lastPurchase.get('isCancel')" class="fas fa-window-close reject"></i>
                  </div>
                  <div class="head">
                    ระบบได้รับคำสั่งซื้อจากคุณแล้ว ({{!lastPurchase.get('isCancel') ? lastPurchase.get('isConfirm') ? 'คำสั่งซื้อได้รับการยืนยันแล้ว':'รอการตรวจสอบการชำระเงิน':'คำสั่งซื้อถูกยกเลิก'}})
                    <span
                      class="refresh"
                      @click="getPurchaseOrder()"
                    >
                      <i class="fas fa-redo-alt"></i>(รีเฟรช)
                    </span>
                    <span
                      v-if="lastPurchase"
                    >{{dateFormat(lastPurchase.lastQuery,'DD/MM/YY, HH:mm:ss') }}</span>
                  </div>
                  <div
                    class="detail"
                    v-if="!lastPurchase.get('isConfirm') && !lastPurchase.get('isCancel')"
                  >จะมีทีมงานติดต่อกลับเพื่อยืนยันคำสั่งซื้อภายใน 7 วัน</div>
                  <div
                    v-else-if="lastPurchase.get('isConfirm') && !lastPurchase.get('isCancel')"
                    class="detail"
                  >ท่านจะได้รับสินค้า ภายใน 3-5 วันทำการ(ใน กทม. และ ปริมณฑล) 5-7 วันทำการ(ต่างจังหวัด)</div>
                  <div v-else class="detail">คำสั่งซื้อนี้ถูกยกเลิกแล้ว</div>
                  <div class="last-purchase" v-if="lastPurchase">
                    <div
                      class="head"
                    >รายการคำสั่งซื้อล่าสุด ({{dateFormat(lastPurchase.get('purchaseDate'),'DD/MM/YY, HH:mm:ss')}})</div>
                    <div class="order-list">
                      <table class="table table-bordered" v-if="lastPurchase">
                        <tr>
                          <th>ลำดับ</th>
                          <th>ชื่อสินค้า</th>
                          <th>ราคาต่อชิ้น(บาท)</th>
                          <th>จำนวน(ชิ้น)</th>
                          <th>รวมเป็นเงิน(บาท)</th>
                        </tr>
                        <tr
                          v-show="lastPurchase.get('orders')"
                          v-for="(item, index) in lastPurchase.get('orders')"
                          :key="index"
                        >
                          <td>{{index+1}}</td>
                          <td>{{item.productName}}</td>
                          <td class="number">{{eArabic(item.pricePer,2) }}</td>
                          <td class="number">{{eArabic(item.number,0) }}</td>
                          <td class="number">{{eArabic(item.pricePer * item.number,2)}}</td>
                        </tr>
                        <tr>
                          <td class="sum-text" colspan="4">ยอดรวมก่อนภาษี</td>
                          <td class="number">{{eArabic(lastPurchase.get('beforeVat'),2)}}</td>
                        </tr>
                        <tr>
                          <td
                            class="sum-text"
                            colspan="4"
                          >ภาษี {{eArabic(lastPurchase.get('vatPer'),2)}}%</td>
                          <td class="number">{{eArabic(lastPurchase.get('vatBath'),2)}}</td>
                        </tr>
                        <tr>
                          <td class="sum-text" colspan="4">ค่าจัดส่ง</td>
                          <td class="number">{{eArabic(lastPurchase.get('deliveryBath'),2)}}</td>
                        </tr>
                        <tr>
                          <td class="sum-text" colspan="4">ยอดสุทธิ / ยอดโอน</td>
                          <td class="number sum">{{eArabic(lastPurchase.get('cost'),2)}}</td>
                        </tr>
                      </table>
                    </div>

                    <div class="box-address">
                      <div class="head">ข้อมูลสำหรับการจัดส่งล่าสุด</div>
                      <div
                        class="detail"
                      >{{`${lastPurchase.get('orderName')} ${lastPurchase.get('apartmentName')} ${lastPurchase.get('orderAddress')} โทร.${lastPurchase.get('orderTel')}`}}</div>
                    </div>
                    <div class="box-address">
                      <div class="head">ข้อมูลสำหรับออกใบกำกับภาษีล่าสุด</div>
                      <div
                        class="detail"
                      >{{`${lastPurchase.get('taxId')} ${lastPurchase.get('orderNameTax')} ${lastPurchase.get('orderAddressTax')}`}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-md-12">
                <div class="btn-back" @click="toggleModalPurchase">ปิดหน้าต่างนี้</div>
                <div
                  :class="`btn btn-purchase-back ${isLoadBalanceStore || (balanceStore && balanceStore.balanceProduct <=0) ? 'non-active':''}`"
                  @click.prevent="submitPurchaseOrder4(formPurchase)"
                >{{lastPurchase ? text.btnPurchase2 : text.btnPurchase}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="modal-confirm" class="modal-confirm modal-confirm-hide">
        <div class="container container-confirm">
          <div class="header-confirm">
            <div class="text">ยืนยันการสั่งซื้อ</div>
            <div class="box-close" @click="toggleModalConfirm">
              <i class="fas fa-times close-modal"></i>
            </div>
          </div>
          <div class="panel">
            <div class="box-order">
              <div class="head">สรุปรายการสั่งซื้อ ( 1 รายการ )</div>
              <div class="order-list">
                <table class="table table-bordered">
                  <tr>
                    <th>ลำดับ</th>
                    <th>ชื่อสินค้า</th>
                    <th>ราคาต่อชิ้น(บาท)</th>
                    <th>จำนวน(ชิ้น)</th>
                    <th>รวมเป็นเงิน(บาท)</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>{{product.get("name")}}</td>
                    <td class="number">{{eArabic(formPurchase.pricePer,2) }}</td>
                    <td class="number">{{eArabic(formPurchase.number,0) }}</td>
                    <td class="number">{{eArabic(formPurchase.pricePer * formPurchase.number,2)}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text" colspan="4">ยอดรวมก่อนภาษี</td>
                    <td class="number">{{eArabic(formPurchase.beforeVat,2)}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text" colspan="4">ภาษี {{eArabic(formPurchase.vatPer,2)}}%</td>
                    <td class="number">{{eArabic(formPurchase.vatBath,2)}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text" colspan="4">ค่าจัดส่ง</td>
                    <td class="number">{{eArabic(formPurchase.deliveryBath,2)}}</td>
                  </tr>
                  <tr>
                    <td class="sum-text" colspan="4">ยอดสุทธิ / ยอดโอน</td>
                    <td class="number sum">{{eArabic(formPurchase.cost,2)}}</td>
                  </tr>
                </table>
              </div>
              <div class="box-address">
                <div class="head">ข้อมูลสำหรับการจัดส่ง</div>
                <div
                  class="detail"
                >{{`${formPurchase.userName} ${formPurchase.apartmentName} ${formPurchase.apartmentAddress} โทร.${formPurchase.userTel}`}}</div>
              </div>
              <div class="box-address">
                <div class="head">ข้อมูลสำหรับออกใบกำกับภาษี</div>
                <div
                  class="detail"
                >{{`${formPurchase.taxId} ${formPurchase.userNameTax} ${formPurchase.apartmentAddressTax}`}}</div>
              </div>
            </div>

            <div class="box-confirm">
              <div
                class="text"
              >โปรดตรวจสอบความถูกต้อง หากคุณยืนยันในหน้านี้แล้วคุณจะไม่สามารถกลับมาแก้ไขข้อมูลได้อีก</div>
              <div class="confirm">
                <div
                  class="btn-back"
                  @click="toggleModalConfirm"
                  v-show="!isSavingPurchaseOrder"
                >กลับไปแก้ไขข้อมูล</div>
                <div
                  @click.prevent="submitPurchaseOrder3(formPurchase)"
                  v-show="!isSavingPurchaseOrder"
                  :class="`btn-purchase-order ${formPurchase.number < 1 || isSavingImageProof || !formPurchase.proofOfPayment || isSavingPurchaseOrder ? 'non-active':''}`"
                >ยืนยันการชำระเงิน</div>
                <loading-cycle v-show="isSavingPurchaseOrder" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="modal-register" class="modal-register modal-register-hide">
      <div class="container container-register">
        <div class="header-register">
          <div
            class="text"
          >{{registerData && registerData.isSuccess ? text.btnRegister : text.btnRegister2}}</div>
          <div class="box-close" @click="toggleModalRegister">
            <i class="fas fa-times close-modal"></i>
          </div>
        </div>
        <div class="row register">
          <div class="col col-register col-md-12">
            <div class="sol-register">
              <img
                v-if="!registerData || !registerData.isSuccess"
                class="sol-image"
                src="../assets/images/regist-card-reader.jpg"
                alt="sol"
              />
            </div>

            <div class="box-loading" v-show="isLoadRegister">
              <loading-cycle message="กำลังตรวจสอบ.." fontColor="gray" />
            </div>

            <div class="box-register" v-show="!isLoadRegister">
              <label class="label-register" for="input-register">Serial number(S/N) :</label>
              <input
                id="input-register"
                class="input-register"
                type="text"
                placeholder="XXXXXXXXXXXXX (13 หลัก)"
                @keypress="isNumber($event)"
                v-model="inputRegister"
              />
              <div id="btn-register" class="btn-register" @click="checkRegister()">ลงทะเบียน</div>
              <i
                v-show="registerData  && !registerData.isNew && registerData.isSuccess"
                class="far fa-check-circle"
              ></i>
              <i
                v-show="registerData  && !registerData.isNew && !registerData.isSuccess"
                class="far fa-times-circle"
              ></i>
            </div>

            <div
              class="box-registed"
              v-if="!isLoadRegister && registerData && registerData.isSuccess"
            >
              <div class="header-registed">
                {{text.successRegister}}
                <span
                  class="in"
                >(หมายเลขซีเรียลที่ใช้ลงทะเบียน : {{registerData.data.get('serialNumber')}})</span>
              </div>
              <div
                class="text-registed"
                v-if="registerData && registerData.data && registerData.data.get('activatedDate')"
              >ลงทะเบียนวันที่ : {{dateFormat(registerData.data.get('activatedDate'),'DD MMM YYYY, HH:mm:ss')}}</div>
              <div class="file-registed">
                <div class="text">
                  <a
                    class="file"
                    href="https://static.horganice.in.th/cid-reader/dist/Horganice%20CID%20Reader%20Setup%201.0.0.exe"
                    download
                  >
                    <i class="fab fa-windows"></i>
                    <div class="head">Windows Installer</div>
                    <div class="tail">Horganice CID Reader Setup 1.0.0.exe</div>
                  </a>
                  <a
                    class="file"
                    target="_blank"
                    href="https://static.horganice.in.th/cid-reader/dist/%e0%b8%84%e0%b8%b9%e0%b9%88%e0%b8%a1%e0%b8%b7%e0%b8%ad%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%80%e0%b8%9b%e0%b8%b4%e0%b8%94%e0%b9%83%e0%b8%8a%e0%b9%89%e0%b8%87%e0%b8%b2%e0%b8%99.pdf"
                    download
                  >
                    <i class="fas fa-file-pdf"></i>
                    <div class="head">คู่มือการเปิดใช้งาน</div>
                    <div class="tail">คู่มือการเปิดใช้งาน.pdf</div>
                  </a>
                </div>
                <div class="text-detail">รองรับระบบปฎิบัติการ Windows 7 ขึ้นไป ทั้งแบบ32บิทและ64บิท</div>
              </div>

              <div class="box-image-success">
                <!-- <img
                  v-if="registerData && registerData.isSuccess"
                  class="sol-image"
                  src="../assets/images/success-card-reader.jpg"
                  alt="success"
                />-->
                <img
                  v-if="registerData && registerData.isSuccess"
                  class="sol-image img1"
                  src="../assets/images/registed/congrat.png"
                  alt="success"
                />
                <a
                  v-if="registerData && registerData.isSuccess"
                  class="file"
                  href="https://static.horganice.in.th/cid-reader/dist/Horganice%20CID%20Reader%20Setup%201.0.0.exe"
                  download
                >
                  <img
                    class="sol-image img2"
                    src="../assets/images/registed/exe-download.png"
                    alt="success"
                  />
                </a>
                <a
                  v-if="registerData && registerData.isSuccess"
                  class="file"
                  target="_blank"
                  href="https://static.horganice.in.th/cid-reader/dist/%e0%b8%84%e0%b8%b9%e0%b9%88%e0%b8%a1%e0%b8%b7%e0%b8%ad%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%80%e0%b8%9b%e0%b8%b4%e0%b8%94%e0%b9%83%e0%b8%8a%e0%b9%89%e0%b8%87%e0%b8%b2%e0%b8%99.pdf"
                  download
                >
                  <img
                    class="sol-image img3"
                    src="../assets/images/registed/pdf-download.png"
                    alt="success"
                  />
                </a>
                <img
                  v-if="registerData && registerData.isSuccess"
                  class="sol-image img4"
                  src="../assets/images/registed/howto-install.jpg"
                  alt="success"
                />
              </div>

              <div class="btn-back registed" @click="toggleModalRegister">ปิดหน้าต่างนี้</div>
            </div>

            <div
              class="box-regis-fail"
              v-if="!isLoadRegister && !registerData.isNew && !registerData.isSuccess"
            >
              <div class="header-registed">{{text.failRegister}}</div>
              <div class="text-registed" v-show="registerData.errorTH">{{registerData.errorTH}}</div>
              <div class="text-registed" v-show="registerData.errorEN">{{registerData.errorEN}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const text = {
  btnPurchase: "สั่งซื้อสินค้าตอนนี้",
  btnPurchase2: "สั่งซื้อสินค้าเพิ่มเติม",
  btnRegister: "การใช้งานเครื่องอ่านบัตร",
  btnRegister2: "เปิดใช้งานเครื่องอ่านบัตร",
  successRegister: "เปิดใช้งานเครื่องอ่านบัตรสำเร็จ!!",
  failRegister: "เปิดใช้งานเครื่องอ่านบัตรไม่สำเร็จ!!"
};

export default {
  props: ["product"],
  data() {
    return {
      text,
      isDev: false,
      isLoadImage: true,
      isGetConfig: false,
      interested: false,
      inputRegister: "",
      isLoadRegister: false,
      isModalRegister: false,
      isModalPurchase: false,
      isLoadInit: false,
      items: [],
      registerData: {
        isNew: true
      },
      pageOpen: {
        1: true,
        2: false,
        3: false,
        4: false
      },
      banks: [
        {
          no: "",
          bankName: "",
          bankAccount: "",
          bankAccountNo: ""
        }
      ],
      pageNo: 1,
      pageLR: "r",
      perPrice: 0,
      isLoadBalanceStore: false,
      balanceStore: null,
      formPurchase: {
        userId: null,
        userName: "",
        taxId: "",
        userNameTax: "",
        userTel: "",
        apartmentId: "",
        apartmentName: "",
        apartmentAddress: "",
        apartmentAddressTax: "",
        apartmentTel: "",
        vatPer: 7,
        productId: "",
        productName: "",
        deliveryBath: 0,
        pricePer: 0,
        number: 0,
        proofOfPayment: null,
        datePurchaseOrder: null,
        cost: 0,
        vatBath: 0,
        beforeVat: 0,
        note: "",
        isSameAddress: false,
        isSameName: false
      },
      lastPurchase: null,
      isSavingImageProof: false,
      isSavingPurchaseOrder: false,
      isModalConfirm: false
    };
  },
  methods: {
    async init(isTest) {
      this.isLoadInit = true;
      // console.log("HGN CID Reader Detail Page");
      if (!isTest) {
        if (this.$route.query.sessionToken) {
          try {
            this.$user = await this.Parse.User.become(
              this.$route.query.sessionToken
            );
            if (this.$user) {
              this.$sessionToken = this.$user.get("sessionToken");
              this.$route.query.sessionToken = this.$sessionToken;
            } else {
              this.$sessionToken = null;
              this.$router.push("/notSessionToken");
            }
          } catch (error) {
            console.log(error);
            this.$sessionToken = null;
            this.$router.push("/notSessionToken");
          }
        } else {
          this.$router.push("/notSessionToken");
        }
        if (this.$route.query.apartmentId) {
          if (this.$apartmentId != this.$route.query.apartmentId) {
            this.$apartmentId = this.$route.query.apartmentId;
          }
        }
        if (this.$route.query.role) {
          if (this.$role != this.$route.query.role) {
            this.$role = this.$route.query.role;
          }
        }
        // console.log("load user", this.$user);
        if (this.$user) {
          this.getBalanceStore();
          await this.getPurchaseOrder();
          await this.getConfig();
          await this.$user.get("userProfile").fetch();
          let userName = this.getName(this.$user);
          this.formPurchase.userId = this.$user.id;
          this.formPurchase.userTel = this.$user.get("tel")
            ? this.$user.get("tel")
            : "";
          this.formPurchase.userName = userName;
        } else {
        }

        // console.log("user=>>", this.$user);
        // console.log("data==>", this.$apartment);
        // console.log("product==>", this.product);
      } else {
        // console.log("load apartment");
        const apartmentId = `bTvTwN75RI`;
        const user = await this.Parse.User.logIn("0906145594", "qwer1234");
        if (user) {
          await user.get("userProfile").fetch();
          this.$user = user;
          let userName = this.getName(user);
          this.formPurchase.userId = user.id;
          this.formPurchase.userTel = user.get("tel") ? user.get("tel") : "";
          this.formPurchase.userName = userName;

          this.$apartmentId = apartmentId;
          this.getBalanceStore();
          await this.getPurchaseOrder();
          await this.getConfig();
        }
        // console.log("user=>>", this.$user);
        // console.log("data==>", this.$apartment);
        // console.log("product==>", this.product);
      }
      this.isLoadInit = false;
    },
    loaded() {
      if (true) {
        this.isLoadImage = false;
        this.$mount();
      }
    },
    async requestQuotation() {
      this.toggleModalPurchase();
      if (!this.interested) await this.Parse.Cloud.run("MarketProduct_counterInterest", { productId: this.$route.params.productId}).catch(err => {console.log(err)})
      this.interested = true;
    },
    requestPurchase() {
      this.toggleModalConfirm();
    },
    clickRegister() {
      this.toggleModalRegister();
    },
    async getConfig() {
      this.isGetConfig = true;
      try {
        const config = await this.Parse.Config.get();
        const privateParam = config.get("horganiceBankAccount");
        if (privateParam) {
          this.banks[0].no = privateParam.bankCode;
          this.banks[0].bankName = "ธนาคารกสิกรไทย";
          this.banks[0].bankAccount = privateParam.accountName;
          this.banks[0].bankAccountNo = privateParam.accountNumber;
        }
        // console.log(privateParam);
      } catch (error) {
        console.log(error);
      }

      this.isGetConfig = false;
    },
    initStyle() {},
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      // console.log(charCode);
      if (
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 97 && charCode <= 112) ||
        (charCode >= 65 && charCode <= 90)
      ) {
        if (this.inputRegister.length < 13) {
          return true;
        } else {
          evt.preventDefault();
        }
      } else {
        evt.preventDefault();
      }
    },
    isNumberPurchase: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      let key = evt.key;
      let sum = new Number(this.formPurchase.number.toString() + key);
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57 || charCode == 190)
        // && charCode !== 46 //dot
        // && charCode !== 32 //space bar
      ) {
        evt.preventDefault();
      } else {
        console.log(this.balanceStore, sum);
        if (
          sum > -1 &&
          sum < 10 &&
          this.balanceStore &&
          sum <= this.balanceStore.balanceProduct
        ) {
          return true;
        } else {
          evt.preventDefault();
        }
      }
    },
    numberPluse(data) {
      if (data == "+") {
        let number = new Number(this.formPurchase.number) + 1;
        if (
          number > -1 &&
          number < 10 &&
          this.balanceStore &&
          number <= this.balanceStore.balanceProduct
        ) {
          this.formPurchase.number = number;
          this.changeNumber();
        }
      } else if (data == "-") {
        let number = new Number(this.formPurchase.number) - 1;
        if (
          number > -1 &&
          number < 10 &&
          this.balanceStore &&
          number <= this.balanceStore.balanceProduct
        ) {
          this.formPurchase.number = number;
          this.changeNumber();
        }
      }
    },
    eArabic(x, num = 0) {
      if (x)
        return x.toLocaleString(undefined, {
          minimumFractionDigits: num,
          maximumFractionDigits: num
        });
      else return num == 2 ? "0.00" : "0";
    },
    changeNumber: function() {
      if (
        this.formPurchase.number < 0 &&
        this.formPurchase.number > 10 &&
        this.balanceStore &&
        this.formPurchase.number <= this.balanceStore.balanceProduct
      ) {
        return false;
      }
      if (this.product.get("isIncludeVat")) {
        this.formPurchase.cost =
          this.formPurchase.deliveryBath +
          this.formPurchase.pricePer * this.formPurchase.number;
        this.formPurchase.beforeVat =
          (this.formPurchase.cost * 100) / (100 + this.formPurchase.vatPer);
        this.formPurchase.vatBath =
          this.formPurchase.cost - this.formPurchase.beforeVat;
      } else {
        this.formPurchase.beforeVat =
          this.formPurchase.pricePer * this.formPurchase.number;
        this.formPurchase.vatBath =
          (this.formPurchase.beforeVat * this.formPurchase.vatPer) / 100;
        this.formPurchase.cost =
          this.formPurchase.beforeVat +
          this.formPurchase.vatBath +
          this.formPurchase.deliveryBath;
      }
    },
    changeSame: function() {
      if (this.formPurchase && this.formPurchase.userName) {
        if (
          this.formPurchase.isSameAddress &&
          this.formPurchase.apartmentAddress
        ) {
          this.formPurchase.apartmentAddressTax = this.formPurchase.apartmentAddress;
        }
        if (this.formPurchase.isSameName && this.formPurchase.userName) {
          this.formPurchase.userNameTax = this.formPurchase.userName;
        }
      }
    },
    dateFormat(date, dateFormat) {
      if (date) {
        return this.$moment(date).format(dateFormat);
      } else {
        return "";
      }
    },
    getTel(tel) {
      if (tel && tel.length > 0) {
        let temp = "";
        let i = 1;
        for (let res of tel) {
          temp += res;
          if (tel.length != i) {
            temp += ", ";
          }
          i++;
        }
        return temp;
      } else {
        return "";
      }
    },
    getName(user) {
      if (user && user.get("userProfile")) {
        let userProfile = user.get("userProfile");
        let firstName = userProfile.get("firstName");
        let lastName = userProfile.get("lastName");
        return `${firstName} ${lastName}`;
      } else {
        return "";
      }
    },

    async checkRegister() {
      if (this.inputRegister.length < 13) {
        this.registerData.isNew = false;
        this.registerData.isSuccess = false;
        this.registerData.errorTH = `กรุณาใส่หมายเลขซีเรียลให้ครบ 13 หลัก`;
        this.registerData.errorEN = `Please enter the complete 13-digit serial number.`;
      } else if (
        this.registerData &&
        this.registerData.srError == this.inputRegister
      ) {
        this.registerData.isNew = false;
        this.registerData.isSuccess = false;
        this.registerData.errorTH = `ไม่มีหมายเลขซีเรียลนี้ (${this.inputRegister})`;
        this.registerData.errorEN = `Does not have this serial number (${this.inputRegister}).`;
      } else {
        try {
          this.registerData.isNew = false;
          this.registerData.isSuccess = false;
          this.registerData.errorTH = null;
          this.registerData.errorEN = null;
          this.registerData.data = null;

          if (!this.interested) {
            let temp;
            this.interested = true;
            this.isLoadRegister = true;
            temp = await this.Parse.Cloud.run(
              "MarketProduct_checkRegisterCidReader",
              {
                serialNumber: this.inputRegister,
                apartmentId: this.$apartmentId,
                userId: this.$user.id
              }
            );
            this.interested = false;
            // console.log(temp);
            if (temp && temp.isSuccess) {
              this.registerData = {
                isNew: false,
                isSuccess: temp.isSuccess,
                error: temp.error,
                data: temp.data,
                srError: temp.srError
              };
            } else {
              $("#input-register").addClass("input-repeat-error");
              $("#btn-register").addClass("btn-repeat-error");
              this.registerData = {
                isNew: false,
                isSuccess: false,
                errorEN: temp.errorEN ? temp.errorEN : "not data respond",
                errorTH: temp.errorTH ? temp.errorTH : "not data respond",
                data: null,
                srError: temp.srError
              };
            }
            this.isLoadRegister = false;
          }
        } catch (err) {
          this.registerData = {
            isNew: false,
            isSuccess: false,
            error: err,
            data: null,
            srError: temp.srError
          };
          this.isLoadRegister = false;
          console.log(err);
        }
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async getPurchaseOrder() {
      let apartmentId = this.$apartmentId;
      let dataApartment;
      if (apartmentId)
        dataApartment = await this.Parse.Cloud.run(
          "MarketProduct_getDataPurchaseByApartmentId",
          {
            apartmentId
          }
        );
      if (dataApartment) {
        this.$apartment = dataApartment;
        this.formPurchase.apartmentId = apartmentId;
        this.formPurchase.apartmentName = dataApartment.apartmentName;
        this.formPurchase.apartmentAddress = dataApartment.apartmentAddress;
        this.formPurchase.apartmentTel = this.getTel(
          dataApartment.apartmentTel
        );
        this.lastPurchase = dataApartment.lastPurchase;
        if (this.lastPurchase) {
          this.lastPurchase.lastQuery = this.$moment();
          this.pageOpen[1] = false;
          this.pageOpen[2] = false;
          this.pageOpen[3] = false;
          this.pageOpen[4] = true;
          this.pageNo = 4;
          this.pageLR = "l";
        }
        let pricePer = this.product.get("price");

        this.items.push({
          image:
            this.product.get("images").length > 0
              ? this.product.get("images")[0]
              : null
        });

        this.formPurchase.productId = this.product.id;
        this.formPurchase.productName = this.product.get("name");
        this.formPurchase.pricePer = pricePer;
        this.formPurchase.beforeVat = pricePer * this.formPurchase.number;
        this.formPurchase.vatBath =
          (this.formPurchase.beforeVat * this.formPurchase.vatPer) / 100;
        this.formPurchase.cost =
          this.formPurchase.beforeVat + this.formPurchase.vatBath;
      }
    },
    async getBalanceStore() {
      try {
        this.isLoadBalanceStore = true;
        this.balanceStore = await this.Parse.Cloud.run(
          "MarketProduct_countBalanceStore",
          {
            productCode: "CID"
          }
        );
        this.isLoadBalanceStore = false;
      } catch (error) {
        console.log(error);
      }
    },
    async processImageProof(event) {
      if (event.target.files[0]) {
        this.isSavingImageProof = true;
        // console.log("in saving:", this.formPurchase.proofOfPayment);
        let image = event.target.files[0];
        try {
          let file64 = await this.getBase64(image);
          if (file64) {
            let parseFile = new this.Parse.File(
              "imageProofOfPayment.jpg",
              { base64: file64 },
              image.type
            );
            let fileSave = await parseFile.save();
            if (fileSave) this.formPurchase.proofOfPayment = fileSave;
            this.isSavingImageProof = false;
            // this.$refs.formPurchaseOrder.reset(); // if you need to re-use field or drop the same files multiple times
            // console.log("fin:", this.formPurchase.proofOfPayment);
          }
        } catch (error) {
          console.log(error);
          this.isSavingImageProof = false;
        }
      } else {
        // alert("file not found");
      }
    },
    async submitPurchaseOrder1(data) {
      this.pageOpen[2] = true;
      this.pageNo = 2;
      this.pageLR = "r";
      // console.log(data);
    },
    async submitPurchaseOrder2(data) {
      this.pageOpen[3] = true;
      this.pageNo = 3;
      this.pageLR = "r";
      // console.log(data);
    },
    async submitPurchaseOrder3(data) {
      await this.savePurchaseOrder(data);
      this.pageOpen[1] = false;
      this.pageOpen[2] = false;
      this.pageOpen[3] = false;
      this.pageOpen[4] = true;
      this.pageNo = 4;
      this.pageLR = "r";
      this.toggleModalConfirm();
      this.getBalanceStore();
      // console.log(data);
    },
    async submitPurchaseOrder4(data) {
      this.pageOpen[1] = true;
      this.pageOpen[2] = false;
      this.pageOpen[3] = false;
      this.pageOpen[4] = true;
      this.pageNo = 1;
      this.pageLR = "r";

      this.formPurchase.number = 0;
      this.formPurchase.beforeVat = 0;
      this.formPurchase.vatBath = 0;
      this.formPurchase.cost = 0;
      this.formPurchase.proofOfPayment = null;
      this.formPurchase.taxId = "";
      this.formPurchase.userNameTax = "";
      this.formPurchase.apartmentAddressTax = "";
      this.formPurchase.isSameName = false;
      this.formPurchase.isSameAddress = false;
    },
    async savePurchaseOrder(data) {
      try {
        if (!this.isSavingPurchaseOrder) {
          this.isSavingPurchaseOrder = true;
          this.lastPurchase = await this.Parse.Cloud.run(
            "MarketProduct_savePurchaseOrder",
            {
              data
            }
          );
          if (this.lastPurchase) {
            this.lastPurchase.lastQuery = this.$moment();
          }
          this.isSavingPurchaseOrder = false;
        }

        // console.log("lastPurchase--?>", this.lastPurchase);
      } catch (err) {
        console.log(err);
      }
    },

    toggleModalPurchase() {
      if (this.isModalPurchase) {
        this.isModalPurchase = false;
      } else {
        this.isModalPurchase = true;
      }
    },
    toggleModalRegister() {
      if (this.isModalRegister) {
        this.isModalRegister = false;
      } else {
        this.isModalRegister = true;
      }
    },
    toggleModalConfirm() {
      if (this.isModalConfirm) {
        this.isModalConfirm = false;
      } else {
        this.isModalConfirm = true;
      }
    }
  },
  computed: {
    imageUrl() {
      if (false) {
        return "https://png.pngtree.com/thumb_back/fw800/background/20190221/ourmid/pngtree-2-5d-carnival-background-banner-image_17585.jpg";
        // return `${""}.jpg`;
      } else {
        return require("../assets/images/banner/card-reader-bn2.jpg");
      }
    },
    checkAddress() {
      if (this.formPurchase) {
        if (
          this.formPurchase.userId &&
          this.formPurchase.userName &&
          this.formPurchase.userTel &&
          this.formPurchase.apartmentId &&
          this.formPurchase.apartmentName &&
          this.formPurchase.apartmentAddress &&
          this.formPurchase.vatPer &&
          this.formPurchase.productId &&
          this.formPurchase.pricePer &&
          this.formPurchase.number &&
          this.formPurchase.number > 0
        ) {
          return true;
        } else {
          return false;
        }
      } else return false;
    },
    checkFormPurchase() {
      if (this.formPurchase) {
        let res = "";
        if (!this.formPurchase.number) {
          res += "<div>*จำนวนสั่งซื้อต้องมากกว่า 0</div>";
        }
        return res;
      } else return "<div>**กรุณากรอกข้อมูลให้ครบ**</div>";
    },
    checkFormAddress() {
      if (this.formPurchase) {
        let res = "";
        if (!this.formPurchase.userName) {
          res += "<div>*ไม่มีข้อมูลชื่อผู้สั่งซื้อ</div>";
        }
        if (!this.formPurchase.userTel) {
          res += "<div>*ไม่มีข้อมูลเบอร์โทรผู้สั่งซื้อ</div>";
        }
        if (!this.formPurchase.apartmentName) {
          res += "<div>*ไม่มีข้อมูลชื่อหอพัก</div>";
        }
        if (!this.formPurchase.apartmentAddress) {
          res += "<div>*ไม่มีข้อมูลที่อยู่จัดส่ง</div>";
        }
        return res;
      } else return "<div>**กรุณากรอกข้อมูลให้ครบ**</div>";
    },
    checkFormProof() {
      if (this.formPurchase) {
        let res = "";
        if (!this.formPurchase.userNameTax) {
          res += "<div>*ไม่มีข้อมูล ชื่อผู้สั่งซื้อ/ชื่อบริษัท</div>";
        }
        if (!this.formPurchase.taxId) {
          res +=
            "<div>*ไม่มีข้อมูล เลขบัตรประชาชน/เลขประจำตัวผู้เสียภาษี</div>";
        }
        if (!this.formPurchase.apartmentAddressTax) {
          res += "<div>*ไม่มีข้อมูล ที่อยู่ในการออกใบกำกับภาษี</div>";
        }
        if (!this.formPurchase.proofOfPayment) {
          res += "<div>*กรุณาแนบหลักฐานการโอน</div>";
        }
        return res;
      } else return "<div>**กรุณากรอกข้อมูลให้ครบ**</div>";
    },
    allowPurchase() {
      if (this.formPurchase) {
        if (
          this.formPurchase.userId &&
          this.formPurchase.userName &&
          this.formPurchase.userTel &&
          this.formPurchase.apartmentId &&
          this.formPurchase.apartmentName &&
          this.formPurchase.apartmentAddress &&
          this.formPurchase.apartmentTel &&
          this.formPurchase.vatPer &&
          this.formPurchase.productId &&
          this.formPurchase.pricePer &&
          this.formPurchase.number &&
          this.formPurchase.number > 0 &&
          this.formPurchase.proofOfPayment
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getImage() {
      if (this.banks && this.banks[0] && this.banks[0].no)
        return require(`../assets/banks/${this.banks[0].no}.jpg`);
      else return null;
    }
  },
  created() {
    this.initStyle();
    this.init(this.isDev);
  },
  watch: {
    inputRegister(dataChange) {
      if (
        dataChange &&
        dataChange.length == 10 &&
        this.registerData &&
        this.registerData.srError &&
        this.registerData.srError == dataChange
      ) {
        $("#input-register").addClass("input-repeat-error");
        $("#btn-register").addClass("btn-repeat-error");
      } else {
        $("#input-register").removeClass("input-repeat-error");
        $("#btn-register").removeClass("btn-repeat-error");
      }
    },
    isModalPurchase(isTrue) {
      if (isTrue) {
        $("#main-cid-detail").addClass("modal-open");
        $("#modal-purchase").removeClass("modal-purchase-hide");
      } else {
        $("#main-cid-detail").removeClass("modal-open");
        $("#modal-purchase").addClass("modal-purchase-hide");
      }
    },
    isModalRegister(isTrue) {
      if (isTrue) {
        $("#main-cid-detail").addClass("modal-open");
        $("#modal-register").removeClass("modal-register-hide");
      } else {
        $("#main-cid-detail").removeClass("modal-open");
        $("#modal-register").addClass("modal-register-hide");
      }
    },
    isModalConfirm(isTrue) {
      if (isTrue) {
        $("#modal-confirm").removeClass("modal-confirm-hide");
      } else {
        $("#modal-confirm").addClass("modal-confirm-hide");
      }
    }
  }
};
</script>